import React, { useEffect } from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

declare global {
  interface Window {
    adsbygoogle: unknown[];
  }
}

const AdBanner: React.FC = () => {
  const { user } = useAuth();

  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.error('AdSense error:', e);
    }
  }, []);

  if (user?.isPremium) {
    return null;
  }

  return (
      <Box sx={{ mt: 4, p: 2 }}>
        <Paper elevation={1} sx={{ p: 2, textAlign: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            Pubblicità –{' '}
            <strong>CV Portal Premium</strong> rimuove tutti gli annunci
          </Typography>
          <ins
              className="adsbygoogle"
              style={{ display: 'block' }}
              data-ad-client="ca-pub-6573938451327776"
              data-ad-slot="7925987166"
              data-ad-format="auto"
              data-full-width-responsive="true"
          />
        </Paper>
      </Box>
  );
};

export default AdBanner;